import { Box, Button, Img, Text } from '@chakra-ui/react';

import { useAnalytics } from '@r-client/shared/data/analytics';

import backgroundDesktop from './assets/back.png';
import backgroundMobile from './assets/back-mobile.png';
import logos from './assets/logos.png';

export function BitgetBanner() {
  const analytics = useAnalytics();

  const onBannerClick = () => {
    analytics.track({
      name: 'promo_flash_banner_clicked',
      params: {
        label: 'bitget_banner',
      },
    });
  };

  return (
    <Box
      as="a"
      href="/bitget"
      display="grid"
      gap="8px 32px"
      gridTemplateColumns={{ sm: '1fr auto 1fr' }}
      alignItems="center"
      p={{ base: '12px 16px' }}
      color="white"
      overflow="hidden"
      backgroundColor="#1A0645"
      backgroundImage={{
        base: backgroundMobile,
        sm: backgroundDesktop,
      }}
      backgroundSize={{ base: '100% 100%', sm: 'auto 100%' }}
      backgroundPosition="50% 0"
      backgroundRepeat="no-repeat"
      onClick={onBannerClick}
    >
      <Img
        src={logos}
        h="16px"
        objectFit="contain"
        justifySelf={{ base: 'center', sm: 'flex-start' }}
      />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap="12px"
        textAlign="center"
      >
        <Text
          fontSize="16px"
          letterSpacing="-0.24px"
          size="republic-default"
          variant="republic-default"
          maxW={{ base: '320px', sm: 'none' }}
          sx={{ textWrap: 'balance' }}
        >
          <strong>Access pre-IPO opportunities</strong> (for non-US investors)
        </Text>
      </Box>
      <Box justifySelf={{ sm: 'right' }}>
        <Button
          display="block"
          backgroundColor="transparent"
          as="span"
          color="white"
          p={{ base: '7px 18px', md: '7px 48px' }}
          height="auto"
          borderRadius="3px"
          fontSize="sm-md"
          fontWeight="600"
          lineHeight="21px"
          boxShadow="inset 0 0 0 1px rgba(255,255,255,0.4)"
          variant="republic-default"
          size="md"
          textAlign="center"
          _hover={{
            color: 'inherit',
          }}
        >
          Learn more →
        </Button>
      </Box>
    </Box>
  );
}
